import React from 'react';
import DatePicker from 'react-datepicker';
import de from 'date-fns/locale/de';
import styled from 'styled-components';
import {dimensions} from '@bettermarks/bm-ui-components';

const CalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  h3 {
    margin: 0 0 ${dimensions.spaceL};
    text-align: center;
    font-size: ${dimensions.fontSizeM};
    font-weight: normal;
  }
`;

export function Calendars(
  today: Date,
  startDate: Date,
  setStartDate: React.Dispatch<React.SetStateAction<Date>>,
  endDate: Date,
  setEndDate: React.Dispatch<React.SetStateAction<Date>>
) {
  return (
    <>
      <CalWrapper>
        <h3>Startdatum wählen:</h3>
        <DatePicker
          locale={de}
          minDate={today}
          selected={startDate}
          onChange={(date: Date) => setStartDate(date)}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          inline
          dateFormat='MM/dd/yyyy'
          showTimeInput
          isClearable
          timeInputLabel='von:'
        />
      </CalWrapper>
      <CalWrapper>
        <h3>Enddatum wählen:</h3>
        <DatePicker
          locale={de}
          minDate={today}
          selected={endDate}
          onChange={(date: Date) => setEndDate(date)}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          inline
          dateFormat='MM/dd/yyyy h:mm aa'
          showTimeInput
          timeInputLabel='bis:'
        />
      </CalWrapper>
    </>
  );
}
